export default {
  "site.name": "Kakobuy Polska",
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.shoppingGuide": "Poradnik Zakupowy",
  "nav.guide": "Poradnik",
  "nav.safety": "Bezpieczeństwo",
  "nav.shipping": "Wysyłka",
  "nav.blog": "Blog",
  "hero.title": "Kakobuy Spreadsheet Polska – Najlepsze Znaleziska Produktów w Jednym Miejscu",
  "hero.subtitle": "Znajdź popularne produkty z Chin szybciej dzięki aktualnym listom Kakobuy Spreadsheet. Sprawdzaj kategorie, porównania, przewodniki zakupowe i bezpieczne metody zamawiania.",
  "hero.cta.primary": "Przeglądaj Kakobuy Spreadsheet",
  "hero.cta.secondary": "Jak działa Kakobuy?",
  "hero.trust.1": "Aktualne listy produktów",
  "hero.trust.2": "Przewodniki dla Polski",
  "hero.trust.3": "Porównania produktów",
  "hero.trust.4": "Bezpieczne zakupy",
  "section.problem.title": "Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?",
  "section.problem.col1": "Tradycyjne wyszukiwanie",
  "section.problem.col2": "Kakobuy Spreadsheet",
  "section.problem.row1.title": "Znalezienie produktów",
  "section.problem.row1.traditional": "Kilka godzin",
  "section.problem.row1.kakobuy": "Kilka minut",
  "section.problem.row2.title": "Popularne produkty",
  "section.problem.row2.traditional": "Trudne",
  "section.problem.row2.kakobuy": "Gotowe listy",
  "section.problem.row3.title": "Kategorie",
  "section.problem.row3.traditional": "Brak organizacji",
  "section.problem.row3.kakobuy": "Posegregowane",
  "section.problem.row4.title": "Porównanie",
  "section.problem.row4.traditional": "Ręczne",
  "section.problem.row4.kakobuy": "Szybkie",
  "section.how.title": "Jak to działa?",
  "section.how.step1": "Wybierz kategorię",
  "section.how.step2": "Sprawdź produkty i informacje",
  "section.how.step3": "Przejdź do głównej platformy",
  "section.categories.title": "Kategorie Produktów",
  "section.categories.subtitle": "Wybierz kategorię i odkryj najlepsze produkty w Kakobuy Spreadsheet",
  "section.categories.dropdown": "Wybierz kategorię...",
  "section.article.title": "Kakobuy Spreadsheet – Kompletny Poradnik dla Polskich Kupujących",
  "section.article.excerpt": "Kakobuy to jeden z najpopularniejszych agentów zakupowych, który umożliwia Polakom łatwe zamawianie produktów z chińskich platform takich jak Taobao, Weidian czy 1688. Kakobuy Spreadsheet to nieocenione narzędzie, które pozwala szybko znaleźć sprawdzone produkty, porównać ceny i uniknąć nietrafionych zakupów.",
  "section.article.readmore": "Czytaj cały poradnik",
  "footer.tagline": "Kakobuy Polska – Twoje źródło najlepszych list produktów i przewodników zakupowych dla polskich kupujących.",
  "footer.disclaimer": "Kakobuy Polska jest niezależnym portalem informacyjnym. Nie jesteśmy bezpośrednio powiązani z platformą Kakobuy. Wszystkie linki prowadzące do zewnętrznych stron służą wyłącznie celom informacyjnym.",
  "footer.copyright": "© 2026 Kakobuy Polska. Wszelkie prawa zastrzeżone.",
  "article.title": "Kakobuy Spreadsheet – Kompletny Poradnik dla Polskich Kupujących (2026)",
  "article.intro": "Zakupy na chińskich platformach takich jak Taobao, Weidian czy 1688 stają się coraz popularniejsze wśród polskich konsumentów. Kakobuy wyróżnia się jako jeden z wiodących agentów zakupowych, oferując intuicyjny interfejs, konkurencyjne ceny wysyłki i profesjonalną obsługę. W tym kompleksowym poradniku wyjaśnimy, czym jest Kakobuy Spreadsheet, jak z niego korzystać i dlaczego warto go używać podczas zakupów.",
  "breadcrumb.home": "Strona Główna",
  "breadcrumb.article": "Poradnik Kakobuy Spreadsheet",
  "button.kakobuy": "Kakobuy Spreadsheet",
  "button.buynow": "Buy It Now"
}